<script lang="ts">
    import { mealyMachine_executeSingleStep } from "../../actions/machine";
    import { getUpdateMachineState } from "../../mealy/context";
    import type { MealyExecutionState } from "../../state/executionState";
    import type { MachineStateMealy_Codeschloss } from "../../state/machineState";
    import Door from "../DoorSystem/Door.svelte";

    export let machineState: MachineStateMealy_Codeschloss;
    export let mealyExecutionState: MealyExecutionState;
    export let isExecuting: boolean;

    const updateMachineState = getUpdateMachineState();
    
    function handleButtonClicked(char: string) {
        if (isExecuting) {
            const [newMachineState, stepHasBeenExecuted] = mealyMachine_executeSingleStep(machineState, char);
            updateMachineState(newMachineState);
        }
    }

    $: isOpen = isExecuting && mealyExecutionState.lastTransitionOutput === 'Tür_öffnen';    
</script>

<div style="display: flex; flex-direction: column">
    <div style="display: flex; justify-content: center; height: 160px;">
        <!-- <svg viewBox="0 0 130 180" width="150px"> -->
            <!-- <g transform="translate(40 10)"> -->
                <Door open={isOpen ? 1 : 0} />
            <!-- </g> -->
        <!-- </svg> -->
    </div>

    <div>
        <button on:click={() => handleButtonClicked('1')     }>1</button>
        <button on:click={() => handleButtonClicked('2')     }>2</button>
        <button on:click={() => handleButtonClicked('3')     }>3</button>
        <button on:click={() => handleButtonClicked('4')     }>4</button>
        <button on:click={() => handleButtonClicked('öffnen')} style="width: 50px;">öffnen</button>
    </div>
</div>

<style>        
    button {
        margin: 4px;
        padding: 4px;
        height: 30px;
        width: 30px;
        box-sizing: content-box;

        border: 1px solid #ccc;
        border-radius: 2px;
        color: #000000;

        background-color: #f0f0f0;
    }

    button:hover {
        background-color:#d6d6d6;
        color: #000000;
    }
</style>